export default __webpack_public_path__ + "static/media/water.dc5e368d.jpg";